import React from 'react'
import PropTypes from 'prop-types'
import {
  withTranslation, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS
} from 'LiveBoard/hocs'
import { ShareEmailForm } from 'LiveBoard/components/shared/ShareEmailForm'
import {
  InlineDialog, HORIZONTAL_POSITIONS, VERTICAL_POSITIONS
} from 'shared/UI/InlineDialog'
import { CloseButton } from 'shared/UI/CloseButton'

import './style.css.scss'

const EmailDialog = (props) => {
  return (
    <InlineDialog
      onClose={props.onClose}
      showButtons={false}
      className="email-share-dialog"
      horizontalPosition={HORIZONTAL_POSITIONS.insideLeft}
      verticalPosition={VERTICAL_POSITIONS.outsideBottom}>
      <CloseButton onClose={props.onClose} />
      <h1>{props.getTranslation(TRANSLATION_VALUE_KEYS.shareMessage)}</h1>
      <ShareEmailForm
        themeColorHex={props.themeColorHex}
        onSubmit={props.onSubmit} />
    </InlineDialog>
  )
}

EmailDialog.propTypes = {
  themeColorHex: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
}

export default withTranslation(TRANSLATION_KEYS.emailDialog)(EmailDialog)
